import { createSlice } from '@reduxjs/toolkit';
import { IInitialOrganizasionData } from './types';
import { isArray } from 'chart.js/dist/helpers/helpers.core';

const SLICE_NAME = 'ORGANIZATION_LEVEL_SLICE';

export const initialState: IInitialOrganizasionData = {
  loading: false,
  error: '',
  data: null,

  organizationClients: null,
  loadingorganizationClients: false,
  organizationClientsError: '',

  organizationInvitation: null,
  loadingOrganizationInvitation: false,
  organizationInvitationError: '',


  organizationInvitationViaEmail: null,
  loadingOrganizationInvitationViaEmail: false,
  organizationInvitationViaEmailError: '',


  // client request to join organization

  clientJoinOrganization : null,
  loadingClientJoinOrganization : false,
  clientJoinOrganizationError : '',

  userOrganizations: null,
  loadingUserOrganizations: false,
  userOrganizationsError: '',

  giveAccessToOrganization: null,
  loadingGiveAccessToOrganization: false,
  giveAccessToOrganizationError: '',

  removeAccessToOrganizationState: null,
  loadingRemoveAccessToOrganization: false,
  removeAccessToOrganizationError: '',

  updateUsersPermissions: null,
  loadingUpdateUsersPermissions : false,
  updateUsersPermissionsError : '',


  getOrganizationUsers: null,
  loadingGetOrganizationUsers : false,
  getOrganizationUsersError : '',


  acceptOrganisationInvitations: null,
  loadingAcceptOrganisationInvitations: false,
  acceptOrganisationInvitationsError: '',

  declineOrganisationInvitations: null,
  loadingDeclineOrganisationInvitations: false,
  declineOrganisationInvitationsError: '',



  deleteOrgClient: null,
  loadingDeleteOrgClient: false,
  deleteOrgClientError: '',

  addUser: null,
  loadingAddUser : false,
  addUserError : '',

  removeUser: null,
  loadingRemoveUser : false,
  removeUserError : '',

  getOrganizationSites : null,
  loadingGetOrganizationSites : false,
  getOrganizationSitesError : '',


  createOrganization : null,
  loadingCreateOrganization: false,
  createOrganizationError: '',

  ClientOrganizations : null,
  loadingClientOrganizations : false,
  ClientOrganizationsError : '',
  
  fetchClientSiteList : null,
  loadingFetchClientSiteList : false,
  fetchClientSiteListError : '',

  currentUserOrgAuth : null,
  loadingCurrentUserOrgAuth : false,
  currentUserOrgAuthError :"",

  deleteOrganization : null,
  loadingDeleteOrganization : false,
  deleteOrganizationError : '',

  companies : null,
  loadingCompanies : false,
  companiesError : '',

  // create user company
  loadingCreateUserCompany : false,
  userCompany : null,
  createUserCompanyError : "",

  // add company to organizations
  loadingAddingCompanytoOrg : false,
  AddingCompanytoOrgError : "",
  AddingCompanytoOrg : null,

  // get-company-invitations-to-join-organizations
  loadingInvitationOrganization : false,
  invitationOrganizationError : "",
  invitationOrganization : null,

  loadingcompanyInvetation : false,
  companyInvetation : null,
  companyInvetationError : "",

  loadingCompanyWebsites : false,
  companyWebsitesError : "",
  companyWebsites : null,

  loadingGrantAccess : false,
  grantAccess : null,
  grantAccessError : "",

  OrgsJoined : null,
  loadingOrgsJoined : false,
  OrgsJoinedError : "",
  loadingUpdateCompanyName : false,
  updateNameCompany : null,
  updateCompanyNameError : "",

  loadingGetInfoIndustry : false,
  getInfoIndustryError : "",
  getInfoIndustry : null,

  loadingUpdateInfoIndustry : false,
  updateInfoIndustryError : "",
  updateInfoIndustry : null,

  loadinggetOwnCompanies : false,
  getOwnCompaniesError : "",
  getOwnCompaniesdata  : null,

  loadingaddCategory : false,
  addCategoryError : "",
  addCategorydata  : null,

  loadingupdateCategory : false,
  updateCategoryError : "",
  updateCategorydata  : null,

  loadingdeleteCategory : false,
  deleteCategoryError : "",
  deleteCategorydata  : null,

  loadingCompanyUsers : false,
  CompanyUsersError :'',
  CompanyUsers: [],

  loadingremoveUserFromComp : false,
  removeUserFromCompError :'',
  removeUserFromComp: null,

  loadingassignComanyRole : false,
  assignComanyRoleError : '',
  assignComanyRole :null,
  
  loadingassignComanyPermission : false,
  assignComanyPermissionError : '',
  assignComanyPermission :null,

  loadingassignWebSitePermission : false,
  assignWebSitePermissionError : '',
  assignWebSitePermission :null

};

const organizationSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialState,
  reducers: {
    // adding Client to organization state .
    addClientToOrganizationError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.data = initialState.data;
    },
    addClientToOrganization: (state, { payload }) => {
      state.loading = true;
      state.error = '';
    },
    addClientToOrganizationSuccess: (state, { payload }) => {
      state.loading = false;
      state.data = payload;
    },

    // get the organization client state.
    getOrganizationClientsError: (state, { payload }) => {
      state.loadingorganizationClients = false;
      state.organizationClientsError = payload;
      state.organizationClients = initialState.organizationClients;
    },
    getOrganizationClients: (state, { payload }) => {
      state.loadingorganizationClients = true;
      state.organizationClientsError = '';
    },
    getOrganizationClientsSuccess: (state, { payload }) => {
      state.loadingorganizationClients = false;
      state.organizationClients = payload;
    },

    // get organisation Invitations state.
    getOrganisationInvitationsError: (state, { payload }) => {
      state.loadingOrganizationInvitation = false;
      state.organizationInvitationError = payload;
      state.organizationInvitation = initialState.organizationInvitation;
    },
    getOrganisationInvitations: (state, { payload }) => {
      state.loadingOrganizationInvitation = true;
      state.organizationInvitationError = '';
    },
    getOrganisationInvitationsSuccess: (state, { payload }) => {
      state.loadingOrganizationInvitation = false;
      state.organizationInvitation = payload;
    },

     // adding Client to organization using email  .
     addClientToOrganizationViaEmailError: (state, { payload }) => {
      state.loadingOrganizationInvitationViaEmail = false;
      state.organizationInvitationViaEmailError = payload;
      state.organizationInvitationViaEmail = initialState.organizationInvitationViaEmail;
    },
    addClientToOrganizationViaEmail: (state, { payload }) => {
      state.loadingOrganizationInvitationViaEmail = true;
      state.organizationInvitationViaEmailError = '';
    },
    addClientToOrganizationViaEmailSuccess: (state, { payload }) => {
      state.loadingOrganizationInvitationViaEmail = false;
      state.organizationInvitationViaEmail = payload;
    },



    // client request to join organization

    addClientOrganizationError: (state, { payload }) => {
      state.loadingClientJoinOrganization= false;
      state.clientJoinOrganizationError = payload;
      state.clientJoinOrganization= initialState.clientJoinOrganization;
    },
    addClientOrganization: (state, { payload }) => {
      state.loadingClientJoinOrganization= true;
      state.clientJoinOrganizationError = '';
    },
    addClientOrganizationSuccess: (state, { payload }) => {
      state.loadingClientJoinOrganization= false;
      state.clientJoinOrganization= payload;
    },


    // Give Access To Organization state.
    giveAccessToOrganizationError: (state, { payload }) => {
      state.loadingGiveAccessToOrganization = false;
      state.giveAccessToOrganizationError = payload;
      state.giveAccessToOrganization = initialState.giveAccessToOrganization;
    },
    giveAccessToOrganization: (state, { payload }) => {
      state.loadingGiveAccessToOrganization = true;
      state.giveAccessToOrganizationError = '';
    },
    giveAccessToOrganizationSuccess: (state, { payload }) => {
      state.loadingGiveAccessToOrganization = false;
      state.giveAccessToOrganization = payload;
    },

      // Remove Access To Organization state.
    removeAccessToOrganizationError: (state, { payload }) => {
      state.loadingRemoveAccessToOrganization = false;
      state.removeAccessToOrganizationError = payload;
      state.removeAccessToOrganizationState = initialState.removeAccessToOrganizationState;
    },
    removeAccessToOrganization: (state, { payload }) => {
      state.loadingRemoveAccessToOrganization = true;
      state.removeAccessToOrganizationError = '';
    },
    removeAccessToOrganizationSuccess: (state, { payload }) => {
      state.loadingRemoveAccessToOrganization = false;
      state.removeAccessToOrganizationState = payload;
    },

    _UpdateremoveAccessToOrganizationSagaSucess: (state) => {
      state.removeAccessToOrganizationState = null;
    },
    UpdateremoveAccessToOrganizationSaga: (state) => {
      state.loadingRemoveAccessToOrganization = true;
      state.removeAccessToOrganizationError = '';
    },

      // Update users permissiom state.
    updateUsersPermissionsError: (state, { payload }) => {
      state.loadingUpdateUsersPermissions = false;
      state.updateUsersPermissionsError = payload;
      state.updateUsersPermissions = initialState.updateUsersPermissions;
    },
    updateUsersPermissions: (state, { payload }) => {
      state.loadingUpdateUsersPermissions = true;
      state.updateUsersPermissionsError = '';
    },
    updateUsersPermissionsSuccess: (state, { payload }) => {
      state.loadingUpdateUsersPermissions = false;
      state.updateUsersPermissions = payload;
    },

    // get Organization users state.
    getOrganizationUsersError: (state, { payload }) => {
      state.loadingGetOrganizationUsers = false;
      state.getOrganizationUsersError = payload;
      state.getOrganizationUsers = initialState.getOrganizationUsers;
    },
    getOrganizationUsers: (state, { payload }) => {
      state.loadingGetOrganizationUsers = true;
      state.getOrganizationUsersError = '';
    },
    getOrganizationUsersSuccess: (state, { payload }) => {
      state.loadingGetOrganizationUsers = false;
      state.getOrganizationUsers = payload;
    },


    // accept organisation invitation by invitationId
    acceptOrganisationInvitationError: (state, { payload }) => {
      state.loadingAcceptOrganisationInvitations = false;
      state.acceptOrganisationInvitationsError = payload;
      state.acceptOrganisationInvitations = initialState.acceptOrganisationInvitations;
    },
    acceptOrganisationInvitation: (state, { payload }) => {
      state.loadingAcceptOrganisationInvitations = true;
      state.acceptOrganisationInvitationsError = '';
    },
    acceptOrganisationInvitationSuccess: (state, { payload }) => {
      state.loadingAcceptOrganisationInvitations = false;
      state.acceptOrganisationInvitations = payload;
    },

    // decline organisation invitation by invitationId
    declineOrganisationInvitationError: (state, { payload }) => {
      state.loadingDeclineOrganisationInvitations = false;
      state.declineOrganisationInvitationsError = payload;
      state.declineOrganisationInvitations = initialState.declineOrganisationInvitations;
    },
    declineOrganisationInvitation: (state, { payload }) => {
      state.loadingDeclineOrganisationInvitations = true;
      state.declineOrganisationInvitationsError = '';
    },
    declineOrganisationInvitationSuccess: (state, { payload }) => {
      state.loadingDeclineOrganisationInvitations = false;
      state.declineOrganisationInvitations = payload;
    },

    // delete user from organization
 

    deleteClientFromOrganisationError: (state, { payload }) => {
      state.loadingDeleteOrgClient = false;
      state.deleteOrgClientError = payload;
      state.deleteOrgClient = initialState.deleteOrgClient;
    },
    deleteClientFromOrganisation: (state, { payload }) => {
      state.loadingDeleteOrgClient = true;
      state.deleteOrgClientError = '';
    },
    deleteClientFromOrganisationSuccess: (state, { payload }) => {
      state.loadingDeleteOrgClient = false;
      state.deleteOrgClient = payload;
    },
    
    // add users to organisation state.
    addUserError: (state, { payload }) => {
      state.loadingAddUser = false;
      state.addUserError = payload;
      state.addUser = initialState.addUser;
    },

    addUser: (state, { payload }) => {
      state.loadingAddUser = true;
      state.addUserError = '';
    },

    addUserSuccess: (state, { payload }) => {
      state.loadingAddUser = false;
      state.addUser = payload;
    },

    // remove user from organisation state.
    removeUserError: (state, { payload }) => {
      state.loadingRemoveUser = false;
      state.removeUserError = payload;
      state.removeUser = initialState.removeUser;
    },

    removeUser: (state, { payload }) => {
      state.loadingRemoveUser = true;
      state.removeUserError = '';
    },

    removeUserSuccess: (state, { payload }) => {
      state.loadingRemoveUser = false;
      state.removeUser = payload;
    },

     // Get Organization Sites state.
    getOrganizationSitesError: (state, { payload }) => {
      state.loadingGetOrganizationSites = false;
      state.getOrganizationSitesError = payload;
      state.getOrganizationSites = initialState.getOrganizationSites;
    },

    getOrganizationSites: (state, { payload }) => {
      state.loadingGetOrganizationSites = true;
      state.getOrganizationSitesError = '';
    },

    getOrganizationSitesSuccess: (state, { payload }) => {
      state.loadingGetOrganizationSites = false;
      state.getOrganizationSites = payload;
    },


    // create organization.
    createClientOrganizationError: (state, { payload }) => {
      state.loadingCreateOrganization = false;
      state.createOrganizationError = payload;
      state.createOrganization = initialState.createOrganization;
    },

    createClientOrganization: (state, { payload }) => {
      state.loadingCreateOrganization = true;
      state.createOrganizationError = '';
    },

    createClientOrganizationSuccess: (state, { payload }) => {
      state.loadingCreateOrganization = false;
      state.createOrganization = payload;
    },


    // get Client Organization.
    getClientOrganizationsError: (state, { payload }) => {
      state.loadingClientOrganizations = false;
      state.ClientOrganizationsError = payload;
      state.ClientOrganizations = initialState.ClientOrganizations;
    },

    getClientOrganizations: (state, { payload }) => {
      state.loadingClientOrganizations = true;
      state.ClientOrganizationsError = '';
    },

    getClientOrganizationsSuccess: (state, { payload }) => {
      state.loadingClientOrganizations = false;
      state.ClientOrganizations = payload;
    },

    resetOrganisationState: (state) => {
      state.loadingClientOrganizations = false;
      state.ClientOrganizationsError = '';
      state.ClientOrganizations = null;
    },

    // Get Organization Sites state.
    fetchClientSiteListError: (state, { payload }) => {
      state.loadingFetchClientSiteList = false;
      state.fetchClientSiteListError = payload;
      state.fetchClientSiteList = initialState.fetchClientSiteList;
    },

    fetchClientSiteList: (state) => {
      state.loadingFetchClientSiteList = true;
      state.fetchClientSiteListError = '';
    },

    fetchClientSiteListSuccess: (state, { payload }) => {
      state.loadingFetchClientSiteList = false;
      state.fetchClientSiteList = payload;
    },
    // get the current user organization.
    currentUserOrganizationAuthError: (state, { payload }) => {
      state.loadingCurrentUserOrgAuth = false;
      state.currentUserOrgAuthError = payload;
      state.currentUserOrgAuth = initialState.currentUserOrgAuth;
    },

    currentUserOrganizationAuth: (state, { payload }) => {
      state.loadingCurrentUserOrgAuth = true;
      state.currentUserOrgAuthError = '';
    },

    currentUserOrganizationAuthSuccess: (state, { payload }) => {
      state.loadingCurrentUserOrgAuth = false;
      state.currentUserOrgAuth = payload;
    },


    // delete organization.
     deleteOrganizationfunError: (state, { payload }) => {
      state.loadingDeleteOrganization = false;
      state.deleteOrganizationError = payload;
      state.deleteOrganization = initialState.deleteOrganization;
    },

    deleteOrganizationfun: (state, { payload }) => {
      state.loadingDeleteOrganization = true;
      state.deleteOrganizationError = '';
    },

    deleteOrganizationfunSuccess: (state, { payload }) => {
      state.loadingDeleteOrganization = false;
      state.deleteOrganization = payload;
    },

    // delete organization.
    fetchCompaniesError: (state, { payload }) => {
      state.loadingCompanies = false;
      state.companiesError = payload;
      state.companies = initialState.companies;
    },

    fetchCompanies: (state, { payload }) => {
      state.loadingCompanies = true;
      state.companiesError = '';
    },

    fetchCompaniesSuccess: (state, { payload }) => {
      state.loadingCompanies = false;
      state.companies = payload;
    },

    // get owen companies

    getOwnCompaniesError: (state, { payload }) => {
      state.loadinggetOwnCompanies = false;
      state.getOwnCompaniesError = payload;
      state.getOwnCompaniesdata = initialState.companies;
    },

    getOwnCompanies: (state) => {
      state.loadinggetOwnCompanies = true;
      state.getOwnCompaniesError = '';
    },

    getOwnCompaniesSuccess: (state, { payload }) => {
      state.loadinggetOwnCompanies = false;
      state.getOwnCompaniesdata = payload;
    },


    // Create a new company
    createCompanyError: (state, { payload }) => {
      state.loadingCreateUserCompany = false;
      state.createUserCompanyError = payload;
      state.userCompany = initialState.userCompany;
    },

    createCompany: (state, { payload }) => {
      state.loadingCreateUserCompany = true;
      state.createUserCompanyError = '';
    },

    createCompanySuccess: (state, { payload }) => {
      state.loadingCreateUserCompany = false;
      state.userCompany = payload;
    },

    // add company to organisation
    inviteCompanyToOrganizationError: (state, { payload }) => {
      state.loadingAddingCompanytoOrg = false;
      state.AddingCompanytoOrgError = payload;
      state.AddingCompanytoOrg = initialState.AddingCompanytoOrg;
    },

    inviteCompanyToOrganization: (state, { payload }) => {
      state.loadingAddingCompanytoOrg = true;
      state.AddingCompanytoOrgError = '';
    },

    inviteCompanyToOrganizationSuccess: (state, { payload }) => {
      state.loadingAddingCompanytoOrg = false;
      state.AddingCompanytoOrg = payload;
    },

    // get-company-invitations-to-join-organizations
    getCompanyInvitationsToJoinOrganizationsError: (state, { payload }) => {
      state.loadingInvitationOrganization = false;
      state.invitationOrganizationError = payload;
      state.invitationOrganization = initialState.invitationOrganization;
    },

    getCompanyInvitationsToJoinOrganizations: (state, { payload }) => {
      state.loadingInvitationOrganization = true;
      state.invitationOrganizationError = '';
    },

    getCompanyInvitationsToJoinOrganizationsSuccess: (state, { payload }) => {
      state.loadingInvitationOrganization = false;
      state.invitationOrganization = payload;
    },

    //decline-organization-invitation
    companyDeclinesInvetationError: (state, { payload }) => {
      state.loadingcompanyInvetation = false;
      state.companyInvetationError = payload;
      state.companyInvetation = initialState.companyInvetation;
    },

    companyDeclinesInvetation: (state, { payload }) => {
      state.loadingcompanyInvetation = true;
      state.companyInvetationError = '';
    },

    companyDeclinesInvetationSuccess: (state, { payload }) => {
      state.loadingcompanyInvetation = false;
      state.companyInvetation = payload;
    },


    // accept-organization-invitation
    companyAcceptInvetationError: (state, { payload }) => {
      state.loadingcompanyInvetation = false;
      state.companyInvetationError = payload;
      state.companyInvetation = initialState.companyInvetation;
    },

    companyAcceptInvetation: (state, { payload }) => {
      state.loadingcompanyInvetation = true;
      state.companyInvetationError = '';
    },

    companyAcceptInvetationSuccess: (state, { payload }) => {
      state.loadingcompanyInvetation = false;
      state.companyInvetation = payload;
    },

    // get-own-company-websites
    getCompanyWebsiesError: (state, { payload }) => {
      state.loadingCompanyWebsites = false;
      state.companyWebsitesError = payload;
      state.companyWebsites = initialState.companyWebsites;
    },

    getCompanyWebsies: (state, { payload }) => {
      state.loadingCompanyWebsites = true;
      state.companyWebsitesError = '';
    },

    getCompanyWebsiesSuccess: (state, { payload }) => {
      state.loadingCompanyWebsites = false;
      state.companyWebsites = payload;
    },

    // get-own-company-websites
    grantAccessToOrganizationError: (state, { payload }) => {
      state.loadingGrantAccess = false;
      state.grantAccessError = payload;
      state.grantAccess = initialState.grantAccess;
    },

    grantAccessToOrganization: (state, { payload }) => {
      state.loadingGrantAccess = true;
      state.grantAccessError = '';
    },

    grantAccessToOrganizationSuccess: (state, { payload }) => {
      state.loadingGrantAccess = false;
      state.grantAccess = payload;
    },
    updategrantAccessToOrganizationSuccess: (state) => {
      state.loadingGrantAccess = false;
      state.grantAccess = null;
      state.grantAccessError = '';
    },

    // list of joined organizations
    getJoinedOrganizationeError: (state, { payload }) => {
      state.loadingOrgsJoined = false;
      state.OrgsJoinedError = payload;
      state.OrgsJoined = initialState.OrgsJoined;
    },

    getJoinedOrganization: (state, { payload }) => {
      state.loadingOrgsJoined = true;
      state.OrgsJoinedError = '';
    },

    getJoinedOrganizationSuccess: (state, { payload }) => {
      state.loadingOrgsJoined = false;
      state.OrgsJoined = payload;
    },
    
    updateCompanyNameError: (state, { payload }) => {
      state.loadingUpdateCompanyName = false;
      state.updateCompanyNameError = payload;
      state.updateNameCompany = initialState.updateNameCompany;
    },

    updateCompanyName: (state, { payload }) => {
      state.loadingUpdateCompanyName = true;
      state.updateCompanyNameError = '';
    },

    updateCompanyNameSuccess: (state, { payload }) => {
      state.loadingUpdateCompanyName = false;
      state.updateNameCompany = payload;
    },
    updateCompanyNameMessage: (state) => {
      state.loadingUpdateCompanyName = false;
      state.updateNameCompany = initialState.updateNameCompany;
    },

    getInfoIndustryError: (state, { payload }) => {
      state.loadingGetInfoIndustry = false;
      state.getInfoIndustryError = payload;
      state.getInfoIndustry = initialState.getInfoIndustry;
    },

    getInfosIndustry: (state) => {
      state.loadingGetInfoIndustry = true;
      state.getInfoIndustryError = '';
    },

    getInfoIndustrySuccess: (state, { payload }) => {
      state.loadingGetInfoIndustry = false;
      state.getInfoIndustry = payload;
    },


    updateInfoIndustryError: (state, { payload }) => {
      state.loadingUpdateInfoIndustry = false;
      state.getInfoIndustryError = payload;
      state.getInfoIndustry = initialState.getInfoIndustry;
    },

    updateInfosIndustry: (state, { payload }) => {
      state.loadingUpdateInfoIndustry = true;
      state.getInfoIndustryError = '';
    },

    updateInfoIndustrySuccess: (state, { payload }) => {
      state.loadingUpdateInfoIndustry = false;
      state.getInfoIndustry = payload;
    },

    addCategoryError: (state, { payload }) => {
      state.loadingaddCategory = false;
      state.addCategoryError = payload;
      state.addCategorydata = initialState.addCategorydata;
    },

    addCategory: (state, { payload }) => {
      state.loadingaddCategory = true;
      state.addCategoryError = '';
    },

    addCategorySuccess: (state, { payload }) => {
      state.loadingaddCategory = false;
      state.addCategorydata = payload;
    },


    updateCategoryError: (state, { payload }) => {
      state.loadingupdateCategory = false;
      state.updateCategoryError = payload;
      state.updateCategorydata = initialState.updateCategorydata;
    },

    updateCategory: (state, { payload }) => {
      state.loadingupdateCategory = true;
      state.updateCategoryError = '';
    },

    updateCategorySuccess: (state, { payload }) => {
      state.loadingupdateCategory = false;
      state.updateCategorydata = payload;
    },
    resetState : (state) => {
      state.updateCategorydata = null;
      state.addCategorydata = null ;
    },

     deleteCategoryError: (state, { payload }) => {
      state.loadingdeleteCategory = false;
      state.deleteCategoryError = payload;
      state.deleteCategorydata = initialState.deleteCategorydata;
    },

    deleteCategory: (state, { payload }) => {
      state.loadingdeleteCategory = true;
      state.deleteCategoryError = '';
    },

    deleteCategorySuccess: (state, { payload }) => {
      state.loadingdeleteCategory = false;
      state.deleteCategorydata = payload;
    },

    // get-own-company-users
    getOwnCompanyUsersError: (state, { payload }) => {
      state.loadingCompanyUsers = false;
      state.CompanyUsersError = payload;
      state.CompanyUsers = initialState.CompanyUsers;
    },

    getOwnCompanyUsers: (state, { payload }) => {
      state.loadingCompanyUsers = true;
      state.CompanyUsersError = '';
    },

    getOwnCompanyUsersSuccess: (state, { payload }) => {
      state.CompanyUsers =  [];
      state.loadingCompanyUsers = false;
      state.CompanyUsers[payload?.id] = payload?.data;
    },


    removeUserFromCompanyError: (state, { payload }) => {
      state.loadingremoveUserFromComp = false;
      state.removeUserFromCompError = payload;
      state.removeUserFromComp = initialState.removeUserFromComp;
    },

    removeUserFromCompany: (state, { payload }) => {
      state.loadingremoveUserFromComp = true;
      state.removeUserFromCompError = '';
    },

    removeUserFromCompanySuccess: (state, { payload }) => {
      state.loadingremoveUserFromComp = false;
      state.removeUserFromComp = payload
    },

    assignComanyRoleError: (state, { payload }) => {
      state.loadingassignComanyRole = false;
      state.assignComanyRoleError = payload;
      state.assignComanyRole = initialState.assignComanyRole;
    },

    assignComanyRole: (state, { payload }) => {
      state.loadingassignComanyRole = true;
      state.assignComanyRoleError = '';
    },

    assignComanyRoleSuccess: (state, { payload }) => {
      state.loadingassignComanyRole = false;
      state.assignComanyRole = payload
    },

    assignComanyPermissionError: (state, { payload }) => {
      state.loadingassignComanyPermission = false;
      state.assignComanyPermissionError = payload;
      state.assignComanyPermission = initialState.assignComanyPermission;
    },

    assignComanyPermission: (state, { payload }) => {
      state.loadingassignComanyPermission = true;
      state.assignComanyPermissionError = '';
    },

    assignComanyPermissionSuccess: (state, { payload }) => {
      state.loadingassignComanyPermission = false;
      state.assignComanyPermission = payload
    },

    assignWebSitePermissionError: (state, { payload }) => {
      state.loadingassignWebSitePermission = false;
      state.assignWebSitePermissionError = payload;
      state.assignWebSitePermission = initialState.assignWebSitePermission;
    },

    assignWebSitePermission: (state, { payload }) => {
      state.loadingassignWebSitePermission = true;
      state.assignWebSitePermissionError = '';
    },

    assignWebSitePermissionSuccess: (state, { payload }) => {
      state.loadingassignWebSitePermission = false;
      state.assignWebSitePermission = payload
    },
  },
});

export default organizationSlice;